export const jsonData = {
    SGLT2Inhibitors: {
        category: "SGLT2 inhibitors: Used to treat Type 2 Diabetes. Names end in “flozin”.",
        id: "SGLT2 inhibitors",
        total: 0,
        position: 1,
        moreInfo: 'https://www.diabetes.org.uk/guide-to-diabetes/managing-your-diabetes/treating-your-diabetes/tablets-and-medication/sglt2-inhibitors',
        response: "",
        data: [
            {
                id: 1.1,
                title: "Medicine name 1",
                value: ""
            },
            {
                id: 1.2,
                title: "Medicine name 2",
                value: ""
            },
            {
                id: 1.3,
                title: "Medicine name 3",
                value: ""
            }
        ]
    },
    ACEInhibitors: {
        category: "ACE inhibitors. Names end in “pril”.",
        id: "ACE inhibitors",
        total: 0,
        position: 2,
        moreInfo: 'https://patient.info/heart-health/ace-inhibitors#nav-1',
        response: "",
        data: [
            {
                id: 2.1,
                title: "Medicine name 1",
                value: ""
            },
            {
                id: 2.2,
                title: "Medicine name 2",
                value: ""
            },
            {
                id: 2.3,
                title: "Medicine name 3",
                value: ""
            }
        ]
    },
    Diuretics: {
        category: "Diuretics. Often called “water tablets”, e.g. furosemide, bendroflumethiazide.",
        id: "Diuretics",
        total: 0,
        position: 3,
        moreInfo: 'https://www.bupa.co.uk/health-information/urinary-bladder-problems/diuretics',
        response: "",
        data: [
            {
                id: 3.1,
                title: "Medicine name 1",
                value: ""
            },
            {
                id: 3.2,
                title: "Medicine name 2",
                value: ""
            },
            {
                id: 3.3,
                title: "Medicine name 3",
                value: ""
            }
        ]
    },
    Metformin: {
        category: "Metformin. A diabetes medicine.",
        id: "Metformin",
        total: 0,
        position: 4,
        moreInfo: 'https://patient.info/medicine/metformin-for-diabetes-bolamyn-diagemet-glucient-glucophage-glucorex-meijumet-metabet-metuxtan-sukkarto-yaltormin',
        response: "",
        data: [
            {
                id: 4.1,
                title: "Medicine name 1",
                value: ""
            },
            {
                id: 4.2,
                title: "Medicine name 2",
                value: ""
            },
            {
                id: 4.3,
                title: "Medicine name 3",
                value: ""
            }
        ]
    },
    ARBs: {
        category: "ARBs. Treat heart failure and high blood pressure. Names end in “sartan”.",
        id: "ARBs",
        total: 0,
        position: 5,
        moreInfo: 'https://www.bhf.org.uk/informationsupport/heart-matters-magazine/medical/drug-cabinet/arbs',
        response: "",
        data: [
            {
                id: 5.1,
                title: "Medicine name 1",
                value: ""
            },
            {
                id: 5.2,
                title: "Medicine name 2",
                value: ""
            },
            {
                id: 5.3,
                title: "Medicine name 3",
                value: ""
            }
        ]
    },
    NSAIDs: {
        category: "NSAIDs. Anti-inflammatory painkillers, e.g. ibuprofen, diclofenac, naproxen.",
        id: "NSAIDs",
        total: 0,
        position: 6,
        moreInfo: 'https://patient.info/treatment-medication/painkillers/anti-inflammatory-painkillers',
        response: "",
        data: [
            {
                id: 6.1,
                title: "Medicine name 1",
                value: ""
            },
            {
                id: 6.2,
                title: "Medicine name 2",
                value: ""
            },
            {
                id: 6.3,
                title: "Medicine name 3",
                value: ""
            }
        ]
    },
    Other: {
        category: "Other medicines to stop taking",
        id: "Other medicines",
        total: 0,
        position: 7,
        moreInfo: '',
        response: "",
        data: [
            {
                id: 7.1,
                title: "Medicine name 1",
                value: ""
            },
            {
                id: 7.2,
                title: "Medicine name 2",
                value: ""
            },
            {
                id: 7.3,
                title: "Medicine name 3",
                value: ""
            },
            {
                id: 7.4,
                title: "Medicine name 4",
                value: ""
            }
        ]
    },
}

export default jsonData;